import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '@uigy/shared/components/icons/icon/icon.component';
import { StatusIconType, } from '@uigy/shared/components/icons/interfaces';
import { IconsEnum } from '@uigy/generated/icons.enum';


@Component({
    selector: 'app-ui-icon-status',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IconComponent
    ],
    templateUrl: './ui-icon-status.component.html',
    styleUrl: './ui-icon-status.component.scss'
})
export class UiIconStatusComponent {
  public status = input.required<StatusIconType>();

  public statusToIcon(statusType: StatusIconType): IconsEnum {
    switch (statusType) {
      case StatusIconType.negative:
        return IconsEnum.alert;
      case StatusIconType.positive:
        return IconsEnum.check_circle;
      case StatusIconType.info:
        return IconsEnum.info;
    }
  }
}
